import { useEffect, useState } from "react";
import { Check } from "lucide-react";
import { api } from "@/lib/api";

export const CATS = ["Hepsi", "Kitap", "Soru Bankası", "Fasikül", "Föy", "Deneme"];

export function TemplateThumb({ t }) {
  const band = t.band === "çizgi" ? <div className="h-1.5 border-b-2" style={{ borderColor: t.color }} /> : t.band === "kutu" ? <div className="h-2.5 rounded-sm border flex" style={{ borderColor: t.color }}><div className="w-1/2" style={{ background: t.color }} /></div> : <div className="h-2.5" style={{ background: t.color }} />;
  const lines = <div className="bg-[repeating-linear-gradient(180deg,#cfd6df_0_2px,transparent_2px_8px)] h-full" />;
  return (
    <div className="aspect-[210/297] bg-white border rounded p-2 flex flex-col gap-1.5">
      <div className="flex justify-between"><div className="w-5 h-1.5 rounded-sm" style={{ background: t.color }} /><div className="w-6 h-1.5 bg-[#dfe4ea] rounded-sm" /></div>
      {band}
      {t.structure[0] === "Konu Anlatımı" && <div className="h-4 rounded-sm" style={{ background: `${t.accent}33` }} />}
      <div className="flex-1 grid gap-1.5" style={{ gridTemplateColumns: `repeat(${t.columns}, 1fr)` }}>{Array.from({ length: t.columns }).map((_, k) => <div key={k}>{lines}</div>)}</div>
      <div className="h-1 rounded-sm" style={{ background: t.accent }} />
    </div>
  );
}

export function TemplatePicker({ value, onPick, initialCat = "Hepsi" }) {
  const [all, setAll] = useState([]);
  const [cat, setCat] = useState(initialCat);
  useEffect(() => { api.get("/math/templates").then((r) => setAll(r.data)); }, []);
  const list = all.filter((t) => cat === "Hepsi" || t.category === cat);
  return (
    <div data-testid="template-picker">
      <div className="flex flex-wrap gap-2 mb-3">{CATS.map((c) => <button key={c} type="button" onClick={() => setCat(c)} className={`px-3 py-1.5 rounded-full text-sm border ${cat === c ? "bg-[#13294b] text-white border-[#13294b]" : "bg-white"}`} data-testid={`tpl-cat-${c}`}>{c} {c === "Hepsi" ? `(${all.length})` : `(${all.filter((t) => t.category === c).length})`}</button>)}</div>
      <div className="grid grid-cols-3 sm:grid-cols-5 lg:grid-cols-8 gap-3 max-h-[420px] overflow-y-auto scroll-thin pr-1">{list.map((t) => (
        <button key={t.id} type="button" onClick={() => onPick(t)} className={`relative text-left rounded-lg p-1.5 border-2 transition-colors ${value === t.id ? "border-[#127C8E] bg-[#eef8f9]" : "border-transparent hover:border-[#cfd6df]"}`} data-testid={`tpl-${t.id}`}>
          <TemplateThumb t={t} />
          {value === t.id && <span className="absolute top-2 right-2 w-5 h-5 rounded-full bg-[#127C8E] text-white grid place-items-center"><Check size={12} /></span>}
          <div className="text-[11px] font-semibold text-navy mt-1 leading-tight">{t.layout}</div><div className="text-[10px] text-[#6b7a8c]">{t.category} · {t.name.split(" · ")[1]}</div>
        </button>))}</div>
    </div>
  );
}
